import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import App from './components/App/App';
import { appTheme } from './appTheme';
import { authService } from './services/authService';

// Rafraîchit le jeton d'accès et rejoue les requêtes refusées (401) sans déconnecter
authService.installFetchInterceptor();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ThemeProvider theme={appTheme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    </StrictMode>
);